import {
  PLAN_FETCH_REQUEST,
  PLAN_FETCH_SUCCESS,
  PLAN_FETCH_FAILURE,
  PLAN_CLEAR
} from './planActions'

const INITIAL_STATE = {
  itens: [],
  total: 0,
  filtros: {
    dataInicial: '',
    dataFinal: ''
  },
  loading: false,
  loaded: false,
  error: null
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case PLAN_FETCH_REQUEST:
      return {
        ...state,
        loading: true,
        loaded: false,
        error: null
      }

    case PLAN_FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        error: null,
        itens: action.payload.itens,
        total: action.payload.total,
        filtros: action.payload.filtros
      }

    case PLAN_FETCH_FAILURE:
      return {
        ...state,
        loading: false,
        loaded: true,
        error: action.payload
      }

    case PLAN_CLEAR:
      return {
        ...INITIAL_STATE
      }

    default:
      return state
  }
}